import bindAllMethods from '../../utils/bindAllMethods';
import { SetServiceDependencies } from '../../infra/startup/types';
import IEligibilityClient from '../../clients/oneCloud/eligibility/IEligibilityClient';
import { IEligibilityService } from './IEligibilityService';
import { EligibilityRuleEvaluation, EligibilityRuleInput } from './types';

export class EligibilityService implements IEligibilityService {
  private _eligibilityClient: IEligibilityClient;

  constructor() {
    bindAllMethods(this);
  }

  public setDependencies({ clients }: SetServiceDependencies): void {
    this._eligibilityClient = clients.onecloud.eligibilityClient;
  }

  async checkEligibility(
    rules: EligibilityRuleInput[],
    isPublic = false
  ): Promise<EligibilityRuleEvaluation[]> {
    const response = await this._eligibilityClient?.getEligibility?.(
      rules,
      isPublic
    );

    return response?.eligibility?.items ?? [];
  }
}
